"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSampleRate = exports.getTracesApiKey = exports.getTracesEndpoint = exports.maybeAppendTracesPath = exports.isClassic = exports.createHoneycombSDKLogMessage = exports.defaultOptions = exports.DEFAULT_SAMPLE_RATE = exports.DEFAULT_SERVICE_NAME = exports.DEFAULT_TRACES_ENDPOINT = exports.TRACES_PATH = exports.DEFAULT_API_ENDPOINT = void 0;
// Constants
exports.DEFAULT_API_ENDPOINT = 'https://api.honeycomb.io';
exports.TRACES_PATH = 'v1/traces';
exports.DEFAULT_TRACES_ENDPOINT = `${exports.DEFAULT_API_ENDPOINT}/${exports.TRACES_PATH}`;
exports.DEFAULT_SERVICE_NAME = 'unknown_service';
exports.DEFAULT_SAMPLE_RATE = 1;
/**
 * Default options for the Honeycomb Web SDK.
 */
exports.defaultOptions = {
    apiKey: '',
    tracesApiKey: '',
    endpoint: exports.DEFAULT_TRACES_ENDPOINT,
    tracesEndpoint: exports.DEFAULT_TRACES_ENDPOINT,
    serviceName: exports.DEFAULT_SERVICE_NAME,
    debug: false,
    sampleRate: 1,
    skipOptionsValidation: false,
    localVisualizations: false,
    webVitalsInstrumentationConfig: {
        enabled: true,
    },
};
const createHoneycombSDKLogMessage = (message) => `@honeycombio/opentelemetry-web: ${message}`;
exports.createHoneycombSDKLogMessage = createHoneycombSDKLogMessage;
const classicKeyRegex = /^[a-f0-9]*$/;
const ingestClassicKeyRegex = /^hc[a-z]ic_[a-z0-9]*$/;
/**
 * Determines whether the passed in apikey is classic or not.
 *
 * @param apikey the apikey
 * @returns a boolean to indicate if the apikey was a classic key
 */
function isClassic(apikey) {
    if (apikey == null || apikey.length === 0) {
        return false;
    }
    else if (apikey.length === 32) {
        return classicKeyRegex.test(apikey);
    }
    else if (apikey.length === 64) {
        return ingestClassicKeyRegex.test(apikey);
    }
    return false;
}
exports.isClassic = isClassic;
/**
 * Checks for and appends v1/traces to provided URL if missing when using an HTTP
 * based exporter protocol.
 *
 * @param url the base URL to append traces path to if missing
 * @returns the endpoint with traces path appended if missing
 */
function maybeAppendTracesPath(url) {
    if (url.endsWith(exports.TRACES_PATH) || url.endsWith(`${exports.TRACES_PATH}/`)) {
        return url;
    }
    return url.endsWith('/') ? url + exports.TRACES_PATH : url + '/' + exports.TRACES_PATH;
}
exports.maybeAppendTracesPath = maybeAppendTracesPath;
const getTracesEndpoint = (options) => {
    // use `tracesEndpoint` option unchanged if provided
    if (options === null || options === void 0 ? void 0 : options.tracesEndpoint) {
        return options.tracesEndpoint;
    }
    // use `endpoint` option if provided and append '/v1/traces' if not already appended
    if (options === null || options === void 0 ? void 0 : options.endpoint) {
        return maybeAppendTracesPath(options.endpoint);
    }
    return exports.DEFAULT_TRACES_ENDPOINT;
};
exports.getTracesEndpoint = getTracesEndpoint;
const getTracesApiKey = (options) => {
    return (options === null || options === void 0 ? void 0 : options.tracesApiKey) || (options === null || options === void 0 ? void 0 : options.apiKey);
};
exports.getTracesApiKey = getTracesApiKey;
const getSampleRate = (options) => {
    if (
    // must be a whole positive integer
    typeof (options === null || options === void 0 ? void 0 : options.sampleRate) === 'number' &&
        Number.isSafeInteger(options === null || options === void 0 ? void 0 : options.sampleRate) &&
        (options === null || options === void 0 ? void 0 : options.sampleRate) >= 0) {
        return options === null || options === void 0 ? void 0 : options.sampleRate;
    }
    return exports.DEFAULT_SAMPLE_RATE;
};
exports.getSampleRate = getSampleRate;
